import { Link } from "react-router-dom";
import { MessagesSquare, ChevronRight } from "lucide-react";

export const SoulmateFeedCard = () => (
  <Link to="/heimlicher-chat" data-testid="secret-feed-card" className="secret-card relative block overflow-hidden rounded-3xl p-5 text-white hover:-translate-y-0.5 transition-transform">
    <div className="relative flex items-center gap-4">
      <span className="secret-orb w-14 h-14 rounded-full flex items-center justify-center shrink-0"><MessagesSquare className="w-7 h-7" /></span>
      <div className="min-w-0 flex-1">
        <p className="text-[11px] font-extrabold tracking-[0.2em] text-white/70">HEIMLICHER CHAT</p>
        <h3 className="font-extrabold text-lg leading-tight">Chatte mit jemandem – ganz geheim 🤫</h3>
        <p className="text-xs text-white/75">Nur Decknamen · wer es ist, kommt nie raus</p>
      </div>
      <ChevronRight className="w-5 h-5 shrink-0" />
    </div>
  </Link>
);
